"use strict";

require('../sass/echeck.scss');

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './src/echeck/index';
import select from './src/select';
import css from './src/css';
import OffCanvas, {settings as offCanvasSettings} from './src/offCanvas';

//header account nav dropdown
const headerAccountDropdownEl = select.one('[data-dropdown="header__account-nav__dropdown"]');
if( !!headerAccountDropdownEl ){
    const headerAccountDropdownTriggerEl = select.one('[data-dropdown-trigger]', headerAccountDropdownEl);
    if( !!headerAccountDropdownTriggerEl ){
        headerAccountDropdownTriggerEl.addEventListener("click", (e)=>{
            e.preventDefault();
            css.toggle(headerAccountDropdownEl, 'is-active');
        }, false);
    }
}

const offCanvasElements = select.all('['+ offCanvasSettings.wrapperAttribute +']');
if(offCanvasElements !== null && offCanvasElements.length){
    for(let i= 0, len = offCanvasElements.length; i < len; i++){
        new OffCanvas(offCanvasElements[i]).init();
    }
}

const echeckAppElement = document.getElementById('echeck-app');
if(!!echeckAppElement){
    render((
        <Router>
            <App />
        </Router>
    ), echeckAppElement);
}
